import React, { FC } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Flex, VStack, Link, Text, FlexProps, HStack } from '@chakra-ui/react'
import { BodyBackgroundNuance, Rw1LogoColored, useColor } from '@rw1/shared-lib'
import { LocalePicker } from '../LocalePicker'
import { useLocalization } from '../../localization'

enum Country {
  Germany = 'germany',
  USA = 'usa',
  China = 'china'
}

const companyEmailContact = 'info@realworld-one.com'
const companyPhones: Record<Country, string> = {
  china: '+8613926234932',
  germany: '+497613809980',
  usa: '+19107425192',
}
const FooterFlexResponsive: FC<FlexProps> = (props) => (
  <Flex
    alignItems="center"
    direction={{
      base: 'column',
      md: 'row',
    }}
    gridGap={{
      base: 12,
      md: 6,
    }}
    justifyContent={{
      base: 'center',
      md: 'space-between',
    }}
    {...props}
  />
)

export const Footer: FC = () => {
  const { localize } = useLocalization()
  const textColor = useColor({ nuance: 0, palette: 'text' })
  const footerBackground = useColor({ nuance: BodyBackgroundNuance.Clean, palette: 'body' })

  return (
    <VStack
      alignItems={{
        sm: 'center',
        md: 'stretch',
      }}
      backgroundColor={footerBackground}
      bottom="0"
      direction={{
        sm: 'column',
        md: 'row',
      }
      }
      paddingBottom={2}
      paddingTop={2}
      paddingX={14}
      width="full">
      <FooterFlexResponsive>
        <Rw1LogoColored height="auto" marginLeft={-2} width="9.5rem" />
        <LocalePicker />
      </FooterFlexResponsive>
      <FooterFlexResponsive
        alignItems={{
          base: 'center',
          md: 'flex-end',
        }}>
        <FooterFlexResponsive
          alignItems={{
            base: 'center',
            md: 'flex-start',
          }}
          gridGap={{
            base: 12,
            md: 28,
          }}>
          <VStack alignItems={{
            base: 'center',
            md: 'flex-start',
          }}
            gridGap={0}>
            <Text
              color={textColor}
              fontWeight="semibold"
              textTransform="uppercase">
              {localize('layout.call_us')}
            </Text>
            <HStack>
              <Text>{localize('layout.country_germany')}:</Text>
              <Link
                as="a"
                fontWeight="semibold"
                href={`tel: ${companyPhones.germany}`}
                textDecoration="underline">
                {companyPhones.germany}
              </Link>
            </HStack>
            <HStack>
              <Text>{localize('layout.country_usa')}:</Text>
              <Link
                as="a"
                fontWeight="semibold"
                href={`tel: ${companyPhones.usa}`}
                textDecoration="underline">
                {companyPhones.usa}
              </Link>
            </HStack>
            <HStack>
              <Text>{localize('layout.country_china')}:</Text>
              <Link
                as="a"
                fontWeight="semibold"
                href={`tel: ${companyPhones.china}`}
                textDecoration="underline">
                {companyPhones.china}
              </Link>
            </HStack>
          </VStack>
          <VStack
            alignItems={{
              base: 'center',
              md: 'flex-start',
            }}>
            <Text
              color={textColor}
              fontWeight="semibold"
              textTransform="uppercase">
              {localize('layout.email_us')}
            </Text>
            <Link
              as="a"
              fontWeight="semibold"
              href={`mailto: ${companyEmailContact}`}
              textDecoration="underline">
              {companyEmailContact}
            </Link>
          </VStack>
        </FooterFlexResponsive>
        <VStack alignItems={{
          base: 'center',
          md: "flex-end"
        }}>
          <Link
            as={RouterLink}
            color={textColor}
            fontSize="md"
            fontWeight="bold"
            relative='path'
            textDecoration="underline"
            to="https://realworld-one.com/privacy-notice">
            {localize('common.privacy_policy')}
          </Link>
          <Link
            as={RouterLink}
            color={textColor}
            fontSize="md"
            fontWeight="bold"
            relative='path'
            textDecoration="underline"
            to="https://realworld-one.com/imprint">
            {localize('common.imprint')}
          </Link>
        </VStack>

      </FooterFlexResponsive>
    </VStack >
  )
}
